const customLog = (...args: any[]): void => {
    if (process.env.REACT_APP_LOGGING === 'true') {
        console.log(...args)
    }
}

export default customLog
